import React, { useEffect, useRef, useState } from 'react'
import PropTypes, {shape} from 'prop-types'

import { FormInput }  from '../../01-Atoms/FormInput/FormInput'
import { FormRadios } from '../../01-Atoms/FormRadios/FormRadios'
import { FormSelect } from "../../01-Atoms/FormSelect/FormSelect"
import { FormCheckbox } from "../../01-Atoms/FormCheckbox/FormCheckbox"
import { FormRadioLozenges } from '../../01-Atoms/FormRadioLozenges/FormRadioLozenges'

/**
 * Primary UI component for user interaction
 */
export const FormField = ({label, name, required, onInputChange, type, step, options, validationHash, validationMessages, value }) => {


  if (type === 'radios') {
    return (
      <FormRadios
        label={label}
        name={name}
        required={required}
        onInputChange={onInputChange}
        options={options}
        type={type}
        step={step}
        validationHash={validationHash}
        validationMessages={validationMessages}
        value={value}
      />
    )
  }

  if (type === 'radio-lozenges') {
    return (
      <FormRadioLozenges
        label={label}
        name={name}
        required={required}
        onInputChange={onInputChange}
        options={options}
        type={type}
        step={step}
        validationHash={validationHash}
        validationMessages={validationMessages}
        value={value}
      />
    )
  }

  if (type === 'checkbox') {
    return (
      <FormCheckbox
        label={label}
        name={name}
        required={required}
        onInputChange={onInputChange}
        options={options}
        type={type}
        step={step}
        validationHash={validationHash}
        validationMessages={validationMessages}
        checked={value || false }
      />
    )
  }

  if (type === 'select') {
    return (
      <FormSelect
        label={label}
        name={name}
        required={required}
        onInputChange={onInputChange}
        options={options}
        type={type}
        step={step}
        validationHash={validationHash}
        validationMessages={validationMessages}
        value={value}
      />
    )
  }

  return (
    <FormInput
      label={label}
      name={name}
      required={required}
      onInputChange={onInputChange}
      type={type}
      step={step}
      validationHash={validationHash}
      validationMessages={validationMessages}
      value={value}
    />
  )
}

FormField.propTypes = {
  label             : PropTypes.string.isRequired,
  name              : PropTypes.string.isRequired,
  required          : PropTypes.bool.isRequired,
  onInputChange     : PropTypes.func.isRequired,
  type              : PropTypes.string.isRequired,
  step              : PropTypes.string,
  options           : PropTypes.array,
  validationHash    : PropTypes.string,
  validationMessages: PropTypes.arrayOf(
    shape({
      type   : PropTypes.string,
      message: PropTypes.string,
      pattern: PropTypes.string,
    })
  )
}

FormField.defaultProps = {
  required: false
}
